<div class="alert alert-info align-middle alert-dismissible text-center" role="alert">
  <h5>{{ 'ADMIN_DASHBOARD.WELCOME' | translate: { name: auth.getDisplayName(), role: auth.getDisplayRole() } }}</h5>
</div>

<!-- | aOrAn -->
